import Vue from 'vue'
import Vuex from 'vuex'
import { Manage_admin } from './ManageAdmin.store';
import { Manage_user } from './Manage_user';
import { ListOperator } from './ListOperator';
import { Manage_operator } from './Manage_operator';
import { Manage_average } from './Manage_average.store';
import { Menu } from './Menu';
import { Report } from './Report.module';
import { Report_G2 } from './Report_G2';
import { Report_pcp } from "./Report_pcp";
import { Typegroup } from "./Typegroup.store";
import { Report_pmt } from "./Report_pmt";
import { Report_pt } from "./Report_pt";
import { Report_G5 } from "./Report_G5";
import { Report_G9 } from "./Report_G9";
import { Report_G11 } from "./Report_G11";
import { Report_G12 } from "./Report_G12";
import { Report_G6 } from './Report_G6';
import { Report_PP } from './Report_pp.module';
import { Report_TR } from './Report_tr.module';
import { Report_SI } from './Report_si.module';
import { Report_SC } from './Report_sc.module';
import { Report_view } from './Report_view';
import { Report_ranking } from './Report_ranking';
import { ManageService } from './ManageService.store';
import { Login_store } from './Login_store';
import { Manage_internet } from './Manage_internet';
import { Promotion } from './Promotion.store';
import { TermsAndConditionStore } from './Manage_terms_and_condition';
import { PrivacyDataPolicyStore } from './Manage_privacy_data_policy';
import { SecurityPolicyStore } from './Manage_security_policy';
import { CookiePrivacyStore } from './Manage_cookie_privacy';
import { questionStore } from "./Question.store";
import { articleStore } from "./Article.store";
import { NewsStore } from "./News.store";
import { Report_behavior } from "./Report_behavior";
import { Dashboard } from "./Dashboard.store";
import { Promotion_website } from "./Promotion_website";
import { Report_blockchain } from "./Report_blockchain.store";
import { Report_popular_internet } from "./Report_popular_internet.store";
import { Report_popular_mobile } from "./Report_popular_mobile.store";
import { Manage_request } from "./Manage_request.store"
import { UtelemeStore } from './Uteleme.store'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Manage_admin,
        Manage_user,
        ListOperator,
        Manage_operator,
        Manage_average,
        Menu,
        Report,
        Report_G2,
        Report_pcp,
        Report_pmt,
        Report_pt,
        Report_G5,
        Report_G6,
        Report_G9,
        Report_G11,
        Report_G12,
        Report_PP,
        Report_TR,
        Report_SI,
        Report_SC,
        Report_view,
        Report_ranking,
        Login_store,
        Typegroup,
        ManageService,
        Manage_internet,
        Promotion,
        TermsAndConditionStore,
        PrivacyDataPolicyStore,
        SecurityPolicyStore,
        CookiePrivacyStore,
        questionStore,
        articleStore,
        NewsStore,
        Report_behavior,
        Dashboard,
        Promotion_website,
        Report_blockchain,
        Report_popular_internet,
        Report_popular_mobile,
        Manage_request,
        UtelemeStore
    }
})